// extracted by mini-css-extract-plugin
export default {"commentImage":"CommentImageView-module__jKxt1"};